// Share url button
jQuery(document).ready(function ($) {
    var $temp = $("<input>");
    var $url = $(location).attr('href');
    
    $('.share-button').on('click', function() {
      $("body").append($temp);
      $temp.val($url).select();
      document.execCommand("copy");
      $temp.remove();
      $(".share-text").text("Länk kopierad");
      setTimeout(function() {
        $(".share-text").text("Dela");
      }, 2500);
    })
});